import React from "react";
import DocList from "../../_components/Purchasing/PurchaseDocList";
import { FiFileText, FiClock, FiCheckCircle, FiXCircle, FiUser, FiDollarSign, FiCreditCard, FiHome } from "react-icons/fi";
import { T, fmtMYR } from "../../_components/Purchasing/PurchaseShared";
import { getPurchaseOrders, getPurchaseOrderKpis, deletePurchaseOrder } from "../../_services/purchase.service";

export default function PurchaseOrders() {
    return (
        <DocList
            docType="Purchase Order"
            basePath="/purchases/purchase-orders"
            fetchList={getPurchaseOrders}
            fetchKpis={getPurchaseOrderKpis}
            deleteItem={deletePurchaseOrder}
            statuses={["All", "Draft", "Pending for Approval", "Approved", "Rejected"]}
            kpiCards={[
                { label: "Total POs", key: "total", icon: FiFileText, color: T.accent },
                { label: "Pending", key: "pending", icon: FiClock, color: T.warning },
                { label: "Approved", key: "approved", icon: FiCheckCircle, color: T.success },
                { label: "Rejected", key: "rejected", icon: FiXCircle, color: T.danger },
            ]}
            previewFields={[
                { icon: FiClock, label: "Date", key: "date" },
                { icon: FiHome, label: "Supplier", key: "supplier" },
                { icon: FiUser, label: "Contact Person", key: "contactPerson" },
                { icon: FiDollarSign, label: "Grand Total", key: "grandTotal", render: (v) => fmtMYR(v) },
                { icon: FiCreditCard, label: "Payment Terms", key: "paymentTerms" },
            ]}
            searchOptions={[
                { key: "all", label: "All" },
                { key: "id", label: "PO No." },
                { key: "date", label: "Date" },
                { key: "contactPerson", label: "Contact Person" },
                { key: "Company Name", label: "Supplier" },
            ]}
        />
    );
}
